import {
    FileUploadRes,
    FilterType,
    YASC_CRUD_ALL_MODES_V3,
    YASC_CRUD_PERSISTED_MODES_V3,
    yascClassDefaultSectionModes,
    yascClassDefaultSorting,
    yascClassDescription,
    yascClassDisplayName,
    yascClassFormSectionTitle,
    yascClassFormLayout,
    yascCollection,
    yascDescription,
    yascDisplayName,
    yascEmail,
    yascEntityName,
    yascFormGrid,
    yascFormIgnore,
    yascFormKind,
    yascFormPlaceholder,
    yascFormRows,
    yascFormSubsection,
    yascFormTooltip,
    yascField,
    yascIban,
    yascBic,
    yascTableColumn,
    ColumnType,
    yascMax,
    yascMaxLength,
    yascMin,
    yascMinLength,
    yascNested,
    yascOptionsKey,
    yascPattern,
    yascPhone,
    yascRequired,
    yascTableFilterType,
    yascTableIgnore,
    yascTableIndex,
    yascTableWidth,
    yascUrl, yascFileUpload, MediaType, yascImagePreview,
} from '@yasc/yasc-material-components';
import {AddressDetailRes, AddressReq} from './address.contract';
import {CourtOfficeDetailsRes, TaxOfficeDetailsRes} from './bank.contract';
import {ContactPersonDetailRes} from '../crm';
import {UserDetailsRes} from './user.contract';
import {StandardFormOfAccounts, TypeOfProfitDetermination} from '../../../enums/fibu.enums';
import {InvoiceDocumentFormat} from '../../../enums/invoice-document-format';
import {TimesheetTemplate} from '../../../enums/timesheet-template';
import {TimesheetSignee} from '../../../enums/timesheet-signee';

@yascClassDisplayName('crm_company_bankAccounts_tabLabel')
@yascClassFormSectionTitle('crm_company_bankAccounts_tabLabel')
@yascClassFormLayout({columns: 2, gap: '12px'})
@yascClassDescription('crm_company_bankAccounts_description')
export class CompanyBankAccount {
    @yascField()
    @yascTableIgnore(true)
    @yascFormIgnore()
    guid?: string;

    @yascField()
    @yascDisplayName('formular_bankAccount_accountOwner_label')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    @yascFormGrid({row: 1, column: 1, width: 1})
    accountOwner = '';

    @yascField()
    @yascDisplayName('formular_bankAccount_bankName_label')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    @yascFormGrid({row: 1, column: 2, width: 1})
    bankName = '';

    @yascField()
    @yascDisplayName('formular_bankAccount_iban_label')
    @yascRequired()
    @yascIban()
    @yascMinLength(15)
    @yascMaxLength(34)
    @yascFormPlaceholder('DE89 3704 0044 0532 0130 00')
    @yascFormTooltip('formular_bankAccount_iban_hint')
    @yascFormGrid({row: 2, column: 1, width: 1})
    iban = '';

    @yascField()
    @yascDisplayName('formular_bankAccount_bic_label')
    @yascRequired()
    @yascBic()
    @yascMinLength(8)
    @yascMaxLength(11)
    @yascFormPlaceholder('COBADEFFXXX')
    @yascFormTooltip('formular_bankAccount_bic_hint')
    @yascFormGrid({row: 2, column: 2, width: 1})
    bic = '';

    @yascField()
    @yascDisplayName('formular_bankAccount_default_label')
    @yascTableColumn(ColumnType.CheckBox)
    @yascFormKind('checkbox')
    @yascFormGrid({row: 3, column: 1, width: 1})
    default = false;

    @yascField()
    @yascDisplayName('formular_bankAccount_billingAccountOnly_label')
    @yascTableColumn(ColumnType.CheckBox)
    @yascFormKind('checkbox')
    @yascFormGrid({row: 3, column: 2, width: 1})
    billingAccountOnly = false;

    @yascField()
    @yascTableIgnore(true)
    @yascFormIgnore()
    finApiBankId?: number;

    constructor(init: Partial<CompanyBankAccount> = {}) {
        Object.assign(this, init);
    }
}

@yascClassFormSectionTitle('crm_company_departments_tabLabel')
export class CompanyDepartment {
    @yascTableIgnore(true)
    @yascFormIgnore()
    guid?: string;

    @yascDisplayName('general_name')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    @yascFormGrid({width: 2, fullRow: true})
    name = '';

    constructor(init: Partial<CompanyDepartment> = {}) {
        Object.assign(this, init);
    }
}

/**
 * Editable V3 company domain. API response DTOs intentionally do not participate in editing anymore.
 * The mapper owns the transport/domain boundary and the decorators on this model are the single source for the V3 UI.
 */
@yascClassDefaultSorting([{fieldName: 'name', direction: 'asc', sortIndex: 0}])
@yascEntityName('general_company')
@yascClassDisplayName('general_company')
@yascClassFormSectionTitle('crm_company_basicInfo_tabLabel')
@yascClassFormLayout({columns: 2, gap: '16px'})
@yascClassDescription('crm_company_basicInfo_description')
@yascClassDefaultSectionModes(YASC_CRUD_ALL_MODES_V3)
export class Company {
    @yascTableIgnore(true)
    @yascFormIgnore()
    id = 0;

    @yascDisplayName('general_name')
    @yascTableWidth(2)
    @yascTableIndex(1)
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    @yascTableFilterType(FilterType.text)
    @yascFormSubsection('companyFormSectionGeneral')
    @yascFormGrid({row: 1, column: 1, width: 1})
    name = '';


    @yascDisplayName('crm.companies.logo')
    @yascTableIgnore(true)
    @yascFileUpload({
        mediaType: MediaType.CompanyLogo,
        allowedTypes: ['.png', '.jpg', '.jpeg', '.webp'],
        maxFileSizeMb: 10,
        allowMultiUpload: false,
        showUploadButton: true,
        showUploadProgress: true,
        uploadLabel:'crm.companies.uploadLogo',
    })
    @yascImagePreview({
        size: 150,
        round: false,
        border: false,
        fit: 'cover',
        clickable: true,
        hideLabel: false,
    })
    componyLogo?:FileUploadRes

    @yascDisplayName('general_customerNumber')
    @yascTableIgnore(true)
    @yascMaxLength(50)
    @yascFormPlaceholder('companyCustomerNumberPlaceholder')
    @yascFormTooltip('companyCustomerNumberHint')
    @yascFormSubsection('companyFormSectionGeneral')
    @yascFormGrid({row: 1, column: 2, width: 1})
    customerNumber = '';

    @yascDisplayName('general_email')
    @yascTableWidth(2)
    @yascTableIndex(7)
    @yascEmail()
    @yascMaxLength(255)
    @yascFormPlaceholder('info@company.com')
    @yascTableFilterType(FilterType.text)
    @yascFormSubsection('companyFormSectionGeneral')
    @yascFormGrid({row: 2, column: 1, width: 1})
    email = '';

    @yascDisplayName('general_phone')
    @yascPhone()
    @yascMaxLength(30)
    @yascFormPlaceholder('+49 123 456789')
    @yascFormTooltip('general_phone_hint')
    @yascTableFilterType(FilterType.text)
    @yascFormSubsection('companyFormSectionGeneral')
    @yascFormGrid({row: 2, column: 2, width: 1})
    phone = '';

    @yascDisplayName('general_website')
    @yascUrl()
    @yascMaxLength(255)
    @yascFormPlaceholder('https://www.company.com')
    @yascFormSubsection('companyFormSectionGeneral')
    @yascFormGrid({row: 3, column: 1, width: 2, fullRow: true})
    website = '';

    @yascDisplayName('general_description')
    @yascFormKind('textarea')
    @yascFormRows(4)
    @yascMaxLength(2000)
    @yascFormPlaceholder('companyDescriptionPlaceholder')
    @yascFormSubsection('companyFormSectionGeneral')
    @yascFormGrid({row: 4, column: 1, width: 2, fullRow: true})
    description = '';

    @yascDisplayName('companyTaxNumber')
    @yascTableIgnore(true)
    @yascMaxLength(20)
    @yascPattern(/^[\d/\s-]*$/)
    @yascFormSubsection('companyFormSectionTax')
    @yascFormGrid({row: 1, column: 1, width: 1})
    stNr = '';

    @yascDisplayName('companySalesTaxNumber')
    @yascTableIgnore(true)
    @yascMaxLength(20)
    @yascPattern(/^[A-Z]{2}[A-Z0-9]{2,12}$/)
    @yascFormSubsection('companyFormSectionTax')
    @yascFormGrid({row: 1, column: 2, width: 1})
    ustNr = '';

    @yascDisplayName('companyCourtOffice')
    @yascTableIgnore(true)
    @yascMaxLength(100)
    @yascFormPlaceholder('companyCourtOfficePlaceholder')
    @yascFormSubsection('companyFormSectionTax')
    @yascFormGrid({row: 2, column: 1, width: 1})
    courtOfficeName?: string;

    @yascDisplayName('companyCourtOfficeNr')
    @yascTableIgnore(true)
    @yascMaxLength(64)
    @yascFormPlaceholder('companyCourtOfficeNrPlaceholder')
    @yascFormSubsection('companyFormSectionTax')
    @yascFormGrid({row: 2, column: 2, width: 1})
    courtOfficeNr?: string;

    @yascDisplayName('companyTaxOffice')
    @yascTableIgnore(true)
    @yascMaxLength(100)
    @yascFormSubsection('companyFormSectionTax')
    @yascFormGrid({row: 3, column: 1, width: 2, fullRow: true})
    taxOfficeName?: string;

    @yascDisplayName('billingDefaultPaymentTermsDays')
    @yascTableIgnore(true)
    @yascFormKind('number')
    @yascMin(0)
    @yascFormTooltip('billingDefaultPaymentTermsCustomerHint')
    @yascFormSubsection('companyFormSectionBilling')
    @yascFormGrid({row: 1, column: 1, width: 1})
    billingPaymentTermsDays: number | null = null;

    @yascDisplayName('billingPreferredInvoiceFormat')
    @yascTableIgnore(true)
    @yascFormKind('select')
    @yascOptionsKey('invoiceFormats')
    @yascFormTooltip('billingPreferredInvoiceFormatHint')
    @yascFormSubsection('companyFormSectionBilling')
    @yascFormGrid({row: 1, column: 2, width: 1})
    billingPreferredInvoiceFormat: InvoiceDocumentFormat | null = null;

    @yascDisplayName('timesheetTemplate')
    @yascTableIgnore(true)
    @yascFormKind('select')
    @yascOptionsKey('timesheetTemplates')
    @yascFormTooltip('timesheetTemplateCustomerHint')
    @yascFormSubsection('companyFormSectionBilling')
    @yascFormGrid({row: 3, column: 1, width: 1})
    timesheetTemplate: TimesheetTemplate | null = null;

    @yascDisplayName('timesheetSignee')
    @yascTableIgnore(true)
    @yascFormKind('select')
    @yascOptionsKey('timesheetSignees')
    @yascFormTooltip('timesheetSigneeCustomerHint')
    @yascFormSubsection('companyFormSectionBilling')
    @yascFormGrid({row: 3, column: 2, width: 1})
    timesheetSignee: TimesheetSignee | null = null;

    @yascDisplayName('billingDefaultDiscountPercent')
    @yascTableIgnore(true)
    @yascFormKind('number')
    @yascMin(0)
    @yascMax(100)
    @yascFormSubsection('companyFormSectionBilling')
    @yascFormGrid({row: 2, column: 1, width: 1})
    billingPaymentDiscountPercent: number | null = null;

    @yascDisplayName('billingDefaultDiscountDays')
    @yascTableIgnore(true)
    @yascFormKind('number')
    @yascMin(0)
    @yascFormSubsection('companyFormSectionBilling')
    @yascFormGrid({row: 2, column: 2, width: 1})
    billingPaymentDiscountDays: number | null = null;

    @yascDisplayName('billingEdifactInterchangeId')
    @yascTableIgnore(true)
    @yascMaxLength(70)
    @yascFormPlaceholder('billingEdifactInterchangeIdPlaceholder')
    @yascFormTooltip('billingEdifactInterchangeIdCustomerHint')
    @yascFormSubsection('companyFormSectionEdi')
    @yascFormGrid({row: 1, column: 1, width: 1})
    billingEdifactInterchangeId: string | null = null;

    @yascDisplayName('billingEdifactCompanyReference')
    @yascTableIgnore(true)
    @yascMinLength(4)
    @yascMaxLength(4)
    @yascFormPlaceholder('billingEdifactCompanyReferencePlaceholder')
    @yascFormTooltip('billingEdifactCompanyReferenceHint')
    @yascFormSubsection('companyFormSectionEdi')
    @yascFormGrid({row: 1, column: 2, width: 1})
    billingEdifactCompanyReference: string | null = null;

    @yascTableIgnore(true)
    @yascFormIgnore()
    taxOffice: TaxOfficeDetailsRes = new TaxOfficeDetailsRes();

    @yascTableIgnore(true)
    @yascFormIgnore()
    courtOffice: CourtOfficeDetailsRes = new CourtOfficeDetailsRes();

    @yascTableIgnore(true)
    @yascFormIgnore()
    typeOfProfitDetermination?: TypeOfProfitDetermination;

    @yascTableIgnore(true)
    @yascFormIgnore()
    standardFormOfAccounts?: StandardFormOfAccounts;

    @yascTableIgnore(true)
    @yascFormIgnore()
    logo?: FileUploadRes;

    @yascTableIgnore(true)
    @yascFormIgnore()
    managingDirectors: UserDetailsRes[] = [];

    @yascNested(AddressDetailRes)
    @yascDisplayName('crm_company_addressInfo_tabLabel')
    @yascDescription('crm_company_addressInfo_description')
    @yascTableIgnore(true)
    @yascCollection({
        createItem: () => new AddressReq(),
        getItemId: item => item.id,
        modes: YASC_CRUD_PERSISTED_MODES_V3,
    })
    addresses: AddressDetailRes[] = [];

    @yascField()
    @yascNested(CompanyBankAccount)
    @yascDisplayName('crm_company_bankAccounts_tabLabel')
    @yascDescription('crm_company_bankAccounts_description')
    @yascTableIgnore(true)
    @yascCollection({
        createItem: () => new CompanyBankAccount(),
        itemIdKey: 'guid',
        editOnRowClick: true,
        modes: YASC_CRUD_PERSISTED_MODES_V3,
    })
    bankAccounts: CompanyBankAccount[] = [];

    @yascNested(CompanyDepartment)
    @yascDisplayName('crm_company_departments_tabLabel')
    @yascDescription('crm_company_departments_description')
    @yascTableIgnore(true)
    @yascCollection({
        createItem: () => new CompanyDepartment(),
        itemIdKey: 'guid',
        modes: YASC_CRUD_PERSISTED_MODES_V3,
    })
    departments: CompanyDepartment[] = [];

    @yascNested(ContactPersonDetailRes)
    @yascDisplayName('crm_company_resource_tabLabel')
    @yascDescription('crm_company_resource_description')
    @yascTableIgnore(true)
    @yascCollection({
        readOnly: true,
        linkHref: '/crm/contacts',
        linkLabel: 'crm_company_toResources_button',
        modes: YASC_CRUD_PERSISTED_MODES_V3,
    })
    contactPerson: ContactPersonDetailRes[] = [];

    constructor(init: Partial<Company> = {}) {
        Object.assign(this, init);
    }
}

